import _ from 'lodash'
import { QUOTED } from 'pcb-parts/data/bomStatus';

export const extractQuoteServiceData = (state) => {
  const defaultData = { total: 0, unitPrice: 0, leadTime: 0 }
  if (!state || !state.itemSelected) return defaultData;

  const { quote, parameters } = state

  if (_.isNil(parameters.row_selected) || _.isNil(parameters.column_selected) || (state.code === 'pcbfabrication' && _.isNil(parameters.quote_config_key))) {
    return defaultData
  }

  const lineItem = quote.line_items.find((li) => (
    (state.code === 'pcbassembly' && li.quote_config_key === parameters.supplier_selected)
    || (state.code === 'pcbfabrication' && li.quote_config_key === parameters.quote_config_key)
  ))
  if (!lineItem) return defaultData;

  const total = lineItem.pricing[parameters.row_selected][parameters.column_selected]
  const quantity = lineItem.quantities[parameters.row_selected]
  const unitPrice = Math.round(((total / quantity) + Number.EPSILON) * 100) / 100
  const leadTime = lineItem.lead_times[parameters.column_selected]
  if (!total) return defaultData

  return { total: (unitPrice * quantity), unitPrice, leadTime }
}

export const extractQuoteBomServiceData = (state) => {
  const defaultData = { total: 0, unitPrice: 0, leadTime: 0 };
  const { totals, bom_status, selected_board_qty } = state;
  if (!bom_status || bom_status !== QUOTED) return defaultData;
  const total = totals[selected_board_qty]
  if (!total) return defaultData;

  return { total, unitPrice: (total / selected_board_qty), leadTime: '-' }
}
